export default __webpack_public_path__ + "static/11-b6a3e938dabec240ee6d0a7278dd3c65.jpg";